<h3 class="title configurator-title">{{ 'workbench.plan-shapes.title' | translate }}</h3>

@if (isTunnel) {
  <p-sidebar [(visible)]="kitchenPlanVisible" [modal]="false">
    <div class="row">
      <div class="col-md-11">
        <p-carousel [value]="this.kitchenCarouselMedias" [numVisible]="1" [numScroll]="1" [circular]="true">
          <ng-template let-productUrl pTemplate="item">
            <div class="kitchen-plan-carousel-container">
              <span class="kitchen-plan-carousel-label">{{ productUrl.name }}</span>
              <img [src]="productUrl.url" alt="Project Thumbnail" />
            </div>
          </ng-template>
        </p-carousel>
      </div>
      <div class="col-md-1" class="close-side-bar-container">
        <p-button label="<" styleClass="close-side-bar-button" (onClick)="kitchenPlanVisible = false" />
      </div>
    </div>
  </p-sidebar>
  <div class="row">
    <div class="col-md-4 kitchen-media-container">
      <h4 class="title configurator-subtitle">Conception</h4>
      <div class="kitchen-thumbnail-container">
        @if (this.kitchenThumbnail) {
          <div class="kitchen-thumbnail-container-item">
            <div class="row kitchen-thumbnail-container">
              <img class="kitchen-thumbnail" [src]="this.kitchenThumbnail.url" />
            </div>
          </div>
        }
      </div>
      <h4 class="title configurator-subtitle">Plans de la cuisine</h4>
      <div class="kitchen-plan-container">
        @if (this.kitchenPlans) {
          @for (plan of this.kitchenPlans; track plan) {
            <div class="kitchen-plan-container-item">
              <div class="row kitchen-plan-img-container" (click)="setKitchenPlanVisible(true)">
                <img class="kitchen-plan" [src]="plan.url" />
              </div>
              <div class="kitchen-plan-label-container">
                <span class="kitchen-plan-label">{{ plan.name }}</span>
              </div>
            </div>
          }
        }
      </div>
    </div>
    <div class="col-md-8">
      <h4 class="title configurator-subtitle">
        {{ 'workbench.plan-shapes.plans' | translate }}
      </h4>
      <div class="collapse-block" *ngIf="subStep == 1 && shapes">
        <div class="button-row">
          <button class="section-add-button" (click)="addConfigurationPlan()">
            + {{ 'workbench.plan-shapes.add-workbench' | translate }}
          </button>
          <button class="section-delete-shape-button" (click)="deleteSection()">
            <svg class="iconShapeDelete">
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="assets/img/icons.svg#icon-action-delete">
              </use>
            </svg>
            {{ 'workbench.plan-shapes.delete-workbench' | translate }}
          </button>
        </div>
        <ng-workbench-plan-sections
          *ngFor="let section of configuration.workbenchConfigurationPlans; let index = index"
          [shapes]="shapes"
          [sectionConfiguration]="section"
          [collapseIsVisible]="displayedPlanIndex == section.displayOrder"
          [index]="section.displayOrder"
          (onSectionSelected)="toggleCollapseSection($event, section.displayOrder)"></ng-workbench-plan-sections>

        <p class="text-danger text-right" *ngIf="configuration.hasSuperposition">
          <fa-icon [icon]="faExclamationTriangle"></fa-icon>
          {{ 'workbench.plan-shapes.preview-has-superposition' | translate }}
        </p>
      </div>
    </div>
  </div>
} @else {
  <h4 class="title configurator-subtitle">
    {{ 'workbench.plan-shapes.plans' | translate }}
  </h4>
  <div class="collapse-block" *ngIf="subStep == 1 && shapes">
    <div class="button-row">
      <button class="section-add-button" (click)="addConfigurationPlan()">
        + {{ 'workbench.plan-shapes.add-workbench' | translate }}
      </button>
      <button class="section-delete-shape-button" (click)="deleteSection()">
        <svg class="iconShapeDelete">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="assets/img/icons.svg#icon-action-delete">
          </use>
        </svg>
        {{ 'workbench.plan-shapes.delete-workbench' | translate }}
      </button>
    </div>
    <ng-workbench-plan-sections
      *ngFor="let section of configuration.workbenchConfigurationPlans; let index = index"
      [shapes]="shapes"
      [sectionConfiguration]="section"
      [collapseIsVisible]="displayedPlanIndex == section.displayOrder"
      [index]="section.displayOrder"
      (onSectionSelected)="toggleCollapseSection($event, section.displayOrder)"></ng-workbench-plan-sections>

    <p class="text-danger text-right" *ngIf="configuration.hasSuperposition">
      <fa-icon [icon]="faExclamationTriangle"></fa-icon>
      {{ 'workbench.plan-shapes.preview-has-superposition' | translate }}
    </p>
  </div>
}
<ng-casto-loader *ngIf="subStep == 1 && !shapes"></ng-casto-loader>
